import { render, staticRenderFns } from "./sheet-details.vue?vue&type=template&id=12ff1b63&scoped=true&"
import script from "./sheet-details.vue?vue&type=script&lang=js&"
export * from "./sheet-details.vue?vue&type=script&lang=js&"
import style0 from "./sheet-details.vue?vue&type=style&index=0&id=12ff1b63&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ff1b63",
  null
  
)

export default component.exports